var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Text } from "@chakra-ui/react";
import { SvgSpriteConsumer, theme } from "@pluxee-design-system/core";
import { useEffect, useState } from "react";
import DatePicker from "./DatePicker";
import { DatePickerVariant, } from "./DatePicker.types";
const DateRangePicker = (_a) => {
    var { onChange, startDate, endDate, title } = _a, rest = __rest(_a, ["onChange", "startDate", "endDate", "title"]);
    const [internalStartDate, setStartDate] = useState(null);
    const [internalEndDate, setEndDate] = useState(null);
    useEffect(() => {
        setStartDate(startDate || null);
    }, [startDate]);
    useEffect(() => {
        setEndDate(endDate || null);
    }, [endDate]);
    return (_jsxs(Box, Object.assign({ display: "flex", flexDirection: "column", gap: "0.25rem" }, { children: [title ? (_jsx(Text, Object.assign({ variant: "body.mediumDemibold", color: "semantic.text.primary" }, { children: title }))) : null, _jsxs(Box, Object.assign({ display: "flex", alignItems: "center", width: "fit-content", border: "1px solid", borderColor: "semantic.border.primary", backgroundColor: "semantic.surface.1", _hover: {
                    border: "1px solid",
                    borderColor: "semantic.interactive.primary",
                    backgroundColor: "semantic.cta.secondaryHover",
                }, _focusWithin: {
                    borderColor: `${theme.colors.semantic.outline.focus} !important`,
                    border: "1px solid",
                    boxShadow: `inset 0px 0px 0px 2px ${theme.colors.semantic.outline.focus}`,
                }, gap: "0.75rem", sx: {
                    "& > div:first-of-type .chakra-input__group .chakra-input__right-element": {
                        display: "none",
                    },
                } }, { children: [_jsx(DatePicker, Object.assign({ variant: DatePickerVariant.RANGE_PICKER, value: internalStartDate, onChange: (newStartDate) => {
                            setStartDate(newStartDate);
                            onChange === null || onChange === void 0 ? void 0 : onChange({ startDate: newStartDate, endDate: internalEndDate });
                        }, selectsStart: true, startDate: internalStartDate, endDate: internalEndDate }, rest)), _jsx(SvgSpriteConsumer, { svgId: "minus24", size: 24, color: "semantic.icon.primary" }), _jsx(DatePicker, Object.assign({ variant: DatePickerVariant.RANGE_PICKER_RIGHT, value: internalEndDate, onChange: (newEndDate) => {
                            setEndDate(newEndDate);
                            onChange === null || onChange === void 0 ? void 0 : onChange({ startDate: internalStartDate, endDate: newEndDate });
                        }, selectsEnd: true, startDate: internalStartDate, endDate: internalEndDate, resetDateCustom: () => {
                            setStartDate(null);
                            setEndDate(null);
                            onChange === null || onChange === void 0 ? void 0 : onChange({ startDate: null, endDate: null });
                        } }, rest))] }))] })));
};
export default DateRangePicker;
//# sourceMappingURL=DateRangePicker.js.map